module.exports = __webpack_public_path__ + "static/media/KMH_4876.7de1457d.jpg";